module.exports = __webpack_public_path__ + "img/bg-showcase-3.b0188087.jpg";